import React from 'react';
import { Image, Stack } from '@fluentui/react';
import { Heading2, Text } from 'common/components/Text';
import { ImageConstants } from 'common/ImageConstants';
import { useAssetPath } from 'store';

import { IDialogCardErrorProps } from './DialogCard.Props';
import { useDialogStyles } from './DialogCard.styles';

export const DialogCardError = (props: IDialogCardErrorProps) => {
  const { title, subtitle } = props;
  const styles = useDialogStyles();

  const softImagePath = useAssetPath(ImageConstants.Warning);

  return (
    <Stack grow verticalAlign="center" horizontalAlign="center" tokens={{ childrenGap: 60, padding: 24 }} className={styles.error}>
      <Stack verticalAlign="center" horizontalAlign="center" tokens={{ childrenGap: 16 }}>
        <Stack.Item>
          <Heading2 variant="Title1">{title}</Heading2>
        </Stack.Item>
        {subtitle && (
          <Stack.Item>
            <Text>{subtitle}</Text>
          </Stack.Item>
        )}
      </Stack>
      <Stack.Item>
        <Image src={softImagePath} alt="" width={200} />
      </Stack.Item>
    </Stack>
  );
};
